import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { EventReservationsComponent } from './event-reservations.component';
import { ReservationFormComponent } from './reservation-form/reservation-form.component';
import {EmailService} from '../services/email/email.service';
import {RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MyDatePickerModule
  ],
  declarations: [
    EventReservationsComponent,
    ReservationFormComponent,
  ],
  providers: [
    EmailService
  ]
})
export class EventReservationsModule { }



// WEBPACK FOOTER //
// ./src/app/event-reservations/event-reservations.module.ts